import React from 'react'
import { IconButton, IconButtonVariant } from '..'
import { ReactComponent as DeleteIcon } from '../../../Icons/assets/delete-icon.svg'

export const DeleteWithModalButton = ({
  showModal,
  isDisabled = false,
}: {
  showModal: () => void
  isDisabled?: boolean
}): JSX.Element => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    showModal()
  }

  return (
    <IconButton
      variant={IconButtonVariant.icon}
      onClick={handleClick}
      disabled={isDisabled}
    >
      <DeleteIcon />
    </IconButton>
  )
}
